export enum UserRole {
  Unknown = 'unknown',
  SystemUser = 'system-user',
  Doctor = 'doctor',
  ChannelingPartner = 'channeling-partner',
  Customer = 'customer',
}
